import { DataBean } from "../DataBean";

export class PlanMaintenance extends DataBean {

  public async getPlanMaintenanceCatalogPorPropiedades( properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getPlanMaintenanceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deletePlanMaintenance(idplanmaintenance: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deletePlanMaintenance_Number",
      [idplanmaintenance]
    );
  }

  public async updatePlanMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.PlanMaintenance_updatePlanMaintenance_com.orange.finance.processcontract.bean.PlanMaintenance",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.PlanMaintenance",
        },
      ]
    );
  }
}
